export default __webpack_public_path__ + "static/media/country_name_Icon.4cb7a866.svg";